import classNames from 'classnames';
import type { FC } from 'react';
import React from 'react';
import type { NavigationAnchor } from '../Utils/types';
import { Link } from '~/Partials/Link/Link';
import { LinkType } from '~/Partials/Link/LinkType.csharp';
import { smoothScrollToSectionById } from '~/Partials/Utils/utils';
import styles from './NavigationLink.module.css';

export interface NavigationLinkProps extends NavigationAnchor {
    isSelected: boolean;
    onClick: () => void;
}

export const NavigationLink: FC<React.PropsWithChildren<NavigationLinkProps>> = props => {
    const { isSelected, label, onClick, id, ...restOfProps } = props;

    const onLinkClick = (e?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (e) {
            e.preventDefault();
            smoothScrollToSectionById(id);
            onClick();
        }
    };

    return (
        <Link
            className={classNames(styles.NavigationLink, isSelected && styles['Variant--selected'])}
            type={LinkType.Clear}
            onClick={onLinkClick}
            href={`#${id}`}
            labelClassName={styles.LinkLabelWrapper}
            {...restOfProps}
        >
            {isSelected && <span className={styles.Dot} />}
            <span className={styles.LinkLabel}>{label}</span>
        </Link>
    );
};
